const formatNumberOrDash = (value?: number | null): string | number =>
  !value ? '-' : Math.round(value);

export default formatNumberOrDash;
